export const DIETARY_PREFERENCES = {
  VEGAN: 'is_vegan',
  VEGETARIAN: 'is_vegetarian',
  GLUTEN_FREE: 'is_gluten_free',
  DAIRY_FREE: 'is_dairy_free',
  NUT_FREE: 'is_nut_free',
  SOY_FREE: 'is_soy_free',
  PESCATARIAN: 'is_pescatarian',
  EGG_FREE: 'is_egg_free',
  PEANUT_FREE: 'is_peanut_free',
  SHELLFISH_FREE: 'is_shellfish_free',
};

export enum DietaryPrefs {
  Omnivore = 'is_omnivore',
  Flexitarian = 'is_flexitarian',
  Pescatarian = 'is_pescatarian',
  Vegetarian = 'is_vegetarian',
  Vegan = 'is_vegan',
  DairyFree = 'is_dairy_free',
  GlutenFree = 'is_gluten_free',
  SoyFree = 'is_soy_free',
  TreeNutFree = 'is_nut_free',
  PeanutFree = 'is_peanut_free',
  EggFree = 'is_egg_free',
  ShellfishFree = 'is_shellfish_free',
  SesameFree = 'is_sesame_free',
  GrainFree = 'is_grain_free',
  GarlicFree = 'is_garlic_free',
  OnionFree = 'is_onion_free',
  CaffeineFree = 'is_caffeine_free',
}
